<template>
  <div class="gantt-chart-main">
    <svg :id="`svgContainer${ganttID}`" height="100%" width="100%">
      <g :id="`gridContainer${ganttID}`" fill="none" stroke="rgba(0,0,0,0.3)" stroke-width="1">
      </g>
      <g :id="`leftContainer${ganttID}`" fill="none" stroke="rgba(0,0,0,0.3)" stroke-width="1">
      </g>
    </svg>
    <div class="right-container" :style="{ width: `calc(100% - 22px)` }" @scroll="bodyScroll">
      <div :id="`contentContainer${ganttID}`" :style="{ position: 'absolute', width: `calc(100%)`, height: `calc(100% - ${headerHeight}px)`,
        top: `${headerHeight}px`, left: `0px` }">
        <div :id="`rightContentDiv${ganttID}`" :style="{ position: 'absolute', height: '100%', width: `calc(100% - (${leftWidth + 1}px))`, left: `${leftWidth + 1}px`,
          backgroundColor: 'white' }">
          
        </div>
        <div :id="`leftContentDiv${ganttID}`" :style="{ position: 'absolute', height: '100%', width: `${leftWidth - 2}px`,
          backgroundColor: 'white', zIndex: '3', minHeight: `calc(100%)` }">

        </div>
        <svg :id="`svgRightContainer${ganttID}`" width="100%" style="min-height: 100%">
          <g :id="`svgRightItems${ganttID}`" fill="none" stroke="rgba(0,0,0,0.3)" stroke-width="1">
          </g>
        </svg>
      </div>
      <div :id="`rightContainerDiv${ganttID}`" :style="{ position: 'absolute', height: `${headerHeight - 2}px`,
        top: `0px`, left: `${leftWidth}px`, backgroundColor: 'white', zIndex: '2' }">
        <svg :id="`rightHeaderContainer${ganttID}`" height="100%" style="overflow: visible">
          <g :id="`rightHeaderItems${ganttID}`" fill="none" stroke="rgba(0,0,0,0.3)" stroke-width="1">
          </g>
        </svg>
      </div>
    </div>
    <div class="left-header" :style="{ width: `${leftWidth - 2}px`, height: `${headerHeight - 2}px`, zIndex: '4' }">
      <svg :id="`leftHeaderContainer${ganttID}`" height="100%" width="100%" style="overflow: visible">
        <g :id="`leftHeaderItems${ganttID}`" fill="none" stroke="rgba(0,0,0,0.3)" stroke-width="1">
        </g>
      </svg>
    </div>
    <svg :id="`innerSvg${ganttID}`" style="position: absolute; left: 0; height: 1px; width: 1px; overflow: visible; z-index: 5">
      <g :id="`innerLines${ganttID}`" fill="none" stroke="rgba(0,0,0,0.3)" stroke-width="1">
      </g>
    </svg>
    <div class="splitter" :style="{ left: `${leftWidth + 7.5}px` }" @mousedown="resizeMouseDown"></div>

    <div :id="`tooltip${ganttID}`" class="tooltip tooltip-hidden"></div>
  </div>
</template>

<script>
/* eslint-disable */
var top, right, bottom, left;
var resizingEl = null;
var resizingLeftOffset = 0;
var totalHours = 0;

var grid;
var svgContainer;
var innerLines;
var nowLineTimer;

var rightContainerDiv, rightHeaderContainer, rightHeaderItems; // Right Header section
var leftContentDiv, leftHeaderContainer, leftHeaderItems; // Left Header section
var contentContainer, svgRightContainer, svgRightItems, rightContentDiv; // Right Content section
var columnSize;

var tooltip;

export default {
  components: {
  },
  props: {
    monthName: { type: Array, default: function() { return [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ] } },

    // Public properties
    headerHeight: { type: Number, default: 50 }, // The height of the top header
    leftWidth: { type: Number, default: 300 }, // The width of the left items
    minSteps: { type: Number, default: 1440 }, // The minimum steps in minutes
    ganttID: { type: String, default: 'myGantt' }, // Compulsory to change if you have multiple gantt chart in a page
    leftHeader: { type: Array, default: function() { return [] } }, // Array of the left header with key and title
    startDate: { type: Date, default: function() { return new Date(2020, 8, 21, 0, 0) } }, // The start date and time of the gantt chart
    endDate: { type: Date, default: function() { return new Date(2020, 8, 24, 0, 0) } }, // The end date and time of the gantt chart
    gridSize: { type: Number, default: 40 }, // The size of each column
    rowHeight: { type: Number, default: 20 }, // The height of each row
    items: { type: Array, default: function() { return [] } }, // The items of the all the tasks in the gantt chart
    allKeys: { type: Object, default: function() { return {} } }, // The keys that associate with the items
  },
  methods: {
    createLine: function(x1, x2, y1, y2, stroke, strokeWidth) {
      var line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', x1);
      line.setAttribute('x2', x2);
      line.setAttribute('y1', y1);
      line.setAttribute('y2', y2);

      if (stroke) {
        line.setAttribute('stroke', stroke);
        line.setAttribute('stroke-dasharray', 0);
      }

      if (strokeWidth) {
        line.setAttribute('stroke-width', strokeWidth);
      }

      return line;
    },
    createForeignObject: function(height, width, x, y) {
      var fObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
      fObject.setAttribute('height', height);
      fObject.setAttribute('width', width);
      fObject.setAttribute('y', y);
      fObject.setAttribute('x', x);

      return fObject;
    },
    createSpan: function(text, fontSize, textAlign) {
      var span = document.createElement('span');
      span.style.width = '100%';
      span.style.height = '100%';
      span.style.fontSize = `${fontSize}px`;
      span.style.display = 'flex';
      span.style.justifyContent = textAlign ? 'unset' : 'center';
      span.style.alignItems = 'center';
      span.style.textAlign = textAlign ? textAlign : 'center';
      span.style.padding = '3px';
      span.style.whiteSpace = 'nowrap';
      span.style.padding = '3px';
      span.innerHTML = text;

      return span;
    },
    createContentDiv: function(index) {
      var div = document.createElement('div');
      div.style.borderBottom = '1px solid rgba(128,128,128,0.3)';
      div.style.width = '100%';
      div.style.height = `${this.rowHeight}px`;
      div.style.display = `flex`;
      div.style.alignItems = `center`;
      div.setAttribute('ganttRow', `ganttRow${index}${this.ganttID}`);

      return div;
    },
    createTask: function(rowIndex, start, duration, progress, color, progressColor) {
      var startOffset = this.$dateTime.getDateTimeDifference(new Date(start), this.startDate);
      var offSetMin = (startOffset.hour * 60) + startOffset.min;

      var progressPerc = progress * 100;

      var size = this.gridSize;
      if (columnSize > size) {
        size = columnSize;
      }

      var div = document.createElement('div');
      div.style.width = `${duration / this.minSteps * size}px`;
      div.style.height = '85%';
      div.style.background = `linear-gradient(to right, ${progressColor ? progressColor : 'pink'} ${progressPerc}%, ${color ? color : 'red'} ${progressPerc}%)`;
      div.style.border = '1px solid black';
      // div.style.backgroundColor = color ? color : 'red';
      div.style.position = 'absolute';
      div.style.left = `${(offSetMin / this.minSteps * size) - 1}px`;

      div.setAttribute('index', rowIndex);
      div.setAttribute('start', start);
      div.setAttribute('end', start + (duration * 60 * 1000));

      div.addEventListener('mouseover', this.taskHoverIn);
      div.addEventListener('mouseout', this.taskHoverOut);
      div.addEventListener('mousemove', this.taskHoverMove);

      return div;
    },
    createHoverTask : function(task) {
      var start = this.$dateTime.getDateTime(new Date(task[this.allKeys['starttime']]), 'dd/MM/yyyy HH:mm');
      var end = this.$dateTime.getDateTime(new Date((task[this.allKeys['starttime']] + (task[this.allKeys['duration']] * 60 * 1000))), 'dd/MM/yyyy HH:mm');
      var progress = task[this.allKeys['progress']] ? task[this.allKeys['progress']] * 100 : 0;

      // Create the container to show the start and end time
      var timeDiv = document.createElement('div');
      timeDiv.style.width = '100%';
      timeDiv.innerHTML = `${start} - ${end}`;
      // Create the container to show the start and end time

      // Create the container to show the progress percentage
      var progressDiv = document.createElement('div');
      progressDiv.style.width = '100%';
      progressDiv.innerHTML = `Progress : ${progress}%`;
      // Create the container to show the progress percentage

      // Create the container to show the task with left and right text
      var taskContainer = document.createElement('div');
      taskContainer.style.display = 'flex';
      taskContainer.style.alignItems = 'center';

      var leftSpan = document.createElement('span');
      leftSpan.style.maxWidth = '75px';
      // leftSpan.style.minWidth = '75px';
      leftSpan.style.textAlign = 'right';
      leftSpan.innerHTML = task[this.allKeys['leftText']];

      var taskDiv = document.createElement('div');
      // taskDiv.style.maxWidth = '100px';
      // taskDiv.style.minWidth = '100px';
      taskDiv.style.width = '100%';
      taskDiv.style.height = '20px';
      taskDiv.style.margin = '0 3px';
      taskDiv.style.border = '1px solid black';
      taskDiv.style.background = `linear-gradient(to right, ${task[this.allKeys['progressColor']] ? task[this.allKeys['progressColor']] : 'pink'} ${progress}%, ${task[this.allKeys['color']] ? task[this.allKeys['color']] : 'red'} ${progress}%)`;

      var rightSpan = document.createElement('span');
      rightSpan.style.maxWidth = '75px';
      // rightSpan.style.minWidth = '75px';
      rightSpan.style.textAlign = 'left';
      rightSpan.innerHTML = task[this.allKeys['rightText']];

      taskContainer.appendChild(leftSpan);
      taskContainer.appendChild(taskDiv);
      taskContainer.appendChild(rightSpan);
      // Create the container to show the task with left and right text

      var div = document.createElement('div');
      div.style.width = '250px';
      div.style.backgroundColor = 'white';
      div.style.color = 'black';
      div.style.fontSize = '10px';
      div.style.borderRadius = '3px';
      div.style.margin = '3px 0';
      div.style.padding = '3px';

      div.appendChild(timeDiv);
      div.appendChild(progressDiv);
      div.appendChild(taskContainer);

      return div;
    },
    createCollapsibleButton: function(index, childCount) {
      var div = document.createElement('div');
      var img = document.createElement('img');
      img.src = 'https://img.icons8.com/emoji/48/000000/minus-emoji.png';
      img.height = 10;
      img.width = 10;
      div.appendChild(img);

      div.style.border = '1px solid black';
      div.style.minHeight = '10px';
      div.style.maxHeight = '10px';
      div.style.minWidth = '10px';
      div.style.maxWidth = '10px';
      div.style.display = 'flex';
      div.style.justifyContent = 'center';
      div.style.alignItems = 'center';
      div.style.position = 'absolute';
      div.style.left = '2px';
      div.style.cursor = 'pointer';
      img.setAttribute('index', index);
      img.setAttribute('childCount', childCount);

      div.addEventListener('click', this.collapseClicked)

      return div;
    },
    resizeMouseDown: function(e) {
      resizingEl = e.target;
      var resizingLeft = e.clientX - e.offsetX;
      resizingLeftOffset = resizingLeft - this.leftWidth;
    },
    resizeMouseUp: function(e) {
      if (resizingEl) {
        resizingEl = null;
        var diff = this.$dateTime.getDateTimeDifference(this.endDate, this.startDate);
        var thisGridCount = ((diff.hour * 60) + diff.min) / this.minSteps;
        var thisColumnSize = (grid.getBoundingClientRect().width - this.leftWidth - 3) / thisGridCount;

        if (thisColumnSize > this.gridSize || thisColumnSize > this.gridSize) {
          this.setTimeLineLine();
          this.populateData();
          this.moveNowLine();
        }

        contentContainer.style.width = `${rightHeaderContainer.getBoundingClientRect().width + this.leftWidth + 3}px`;
      }
    },
    resizeMouseMove: function(e) {
      if (resizingEl) {
        e.preventDefault();
        resizingEl.style.left = `${e.clientX - resizingLeftOffset}px`;
        this.leftWidth = parseInt(resizingEl.style.left.split('px').join(''));

        this.setSplitterPosition();
        this.setLeftContainerLine();
        this.setLeftContainerHeader();
      }
    },
    // New methods
    bodyScroll: function(e) {
      leftContentDiv.style.left = `${e.target.scrollLeft}px`;
      rightContainerDiv.style.top = `${e.target.scrollTop}px`;
    },
    // New methods
    // Add line methods
    setSplitterPosition: function() {
      var currentSplitter = document.getElementById(`splitter${this.ganttID}`);
      if (currentSplitter) {
        currentSplitter.setAttribute('x1', this.leftWidth + 10);
        currentSplitter.setAttribute('x2', this.leftWidth + 10);
      } else {
        var splitter = this.createLine(this.leftWidth + 10, this.leftWidth + 10, top, bottom);
        splitter.setAttribute('id', `splitter${this.ganttID}`);
        innerLines.appendChild(splitter);
      }
    },
    setLeftContainerLine: function() {
      var spacing = (this.leftWidth - 2) / this.leftHeader.length;
      var newLeft = 0;

      var allLeftLines = Array.from($(`[leftLine=leftLine${this.ganttID}]`));

      if (allLeftLines.length > 0) {
        allLeftLines.forEach((l) => {
          newLeft += spacing;
          l.setAttribute('x1', newLeft);
          l.setAttribute('x2', newLeft);
        });
      } else {
        for (var i = 0; i < this.leftHeader.length - 1; i++) {
          newLeft += spacing;
          var leftLine = this.createLine(newLeft, newLeft, 0, bottom - 10, null, 0.75);
          leftLine.setAttribute('leftLine', `leftLine${this.ganttID}`);
          leftHeaderItems.appendChild(leftLine);
        }
      }
    },
    setLeftContainerHeader: function() {
      var spacing = (this.leftWidth - 2) / this.leftHeader.length;
      var newLeft = 0;

      var allLeftHeader = Array.from($(`[leftHeader=leftHeader${this.ganttID}]`));
      
      if (allLeftHeader.length > 0) {
        allLeftHeader.forEach((h) => {
          h.setAttribute('width', spacing);
          h.setAttribute('x', newLeft);
          newLeft += spacing;
        });
      } else { 
        this.leftHeader.forEach((h) => {
          var fObject = this.createForeignObject(this.headerHeight, spacing, newLeft, 0);
          fObject.setAttribute('leftHeader', `leftHeader${this.ganttID}`);
          var title = this.createSpan(h.title, 9);
          title.style.whiteSpace = 'unset';
          fObject.appendChild(title);
          leftHeaderItems.appendChild(fObject);
          newLeft += spacing;
        });
      }
    },
    setTimeLineLine: function() {
      var spacing = (this.headerHeight - 2) / 3;
      var newTop = 0;

      var diff = this.$dateTime.getDateTimeDifference(this.endDate, this.startDate);
      var gridCount = ((diff.hour * 60) + diff.min) / this.minSteps;

      columnSize = (grid.getBoundingClientRect().width - this.leftWidth - 3) / gridCount;
      if (columnSize < this.gridSize) {
        columnSize = this.gridSize;
      }

      var allTimelineLine = Array.from($(`[timeline=timeline${this.ganttID}]`));

      if (allTimelineLine.length > 0) {
        allTimelineLine.forEach((t) => {
          t.setAttribute('x2', gridCount * columnSize);
        });
      } else {
        for (var i = 0; i < 2; i++) {
          newTop += spacing;
          var line = this.createLine(0, 0 + (gridCount * columnSize), newTop, newTop);
          line.setAttribute('timeline', `timeline${this.ganttID}`);
          rightHeaderItems.appendChild(line);
        }
      }

      rightHeaderContainer.setAttribute('width', rightHeaderItems.getBoundingClientRect().width - 20);

      this.setTimeVerticalLine(gridCount, newTop);
    },
    setTimeVerticalLine: function(gridCount, top) {
      var newLeft = 0;
      var height = (this.headerHeight - 2) / 3;
      
      var allVertLines = Array.from($(`[timeVert=timeVert${this.ganttID}]`));

      var startTime = this.startDate;

      if (allVertLines.length > 0) {
        allVertLines.forEach((v) => {
          newLeft += columnSize;
          v.setAttribute('x1', newLeft);
          v.setAttribute('x2', newLeft);
        });

        newLeft = 0;
        Array.from($(`[timeObject=timeObject${this.ganttID}]`)).forEach((o) => {
          o.setAttribute('x', newLeft);
          o.setAttribute('width', columnSize);
          newLeft += columnSize;
        });

        rightHeaderContainer.setAttribute('width', rightHeaderItems.getBoundingClientRect().width + this.leftWidth);
      } else {
        for (var i = 0; i < gridCount - 1; i++) {
          var hrs = startTime.getHours() < 10 ? `0${startTime.getHours()}` : `${startTime.getHours()}`;
          var min = startTime.getMinutes() < 10 ? `0${startTime.getMinutes()}` : `${startTime.getMinutes()}`;

          var fObject = this.createForeignObject(height, columnSize, newLeft, top);
          fObject.setAttribute('timeObject', `timeObject${this.ganttID}`);
          fObject.appendChild(this.createSpan(`${hrs}:${min}`, 9));
          rightHeaderItems.appendChild(fObject);

          newLeft += columnSize;
          var line = this.createLine(newLeft, newLeft, top, bottom - 10, null, 0.75);
          line.setAttribute('timeVert', `timeVert${this.ganttID}`);
          rightHeaderItems.appendChild(line);

          startTime = new Date(startTime.getTime() + (this.minSteps * 60000));
        }

        var hrs = startTime.getHours() < 10 ? `0${startTime.getHours()}` : `${startTime.getHours()}`;
        var min = startTime.getMinutes() < 10 ? `0${startTime.getMinutes()}` : `${startTime.getMinutes()}`;

        var fObject = this.createForeignObject(height, columnSize, newLeft, top);
        fObject.setAttribute('timeObject', `timeObject${this.ganttID}`);
        fObject.appendChild(this.createSpan(`${hrs}:${min}`, 9));
        rightHeaderItems.appendChild(fObject);

        rightHeaderContainer.setAttribute('width', rightHeaderItems.getBoundingClientRect().width + this.leftWidth);
      }

      document.getElementById(`contentContainer${this.ganttID}`).style.width = `${rightHeaderItems.getBoundingClientRect().width + this.leftWidth - 7}px`;

      this.setMonth();
    },
    setMonth: function() {
      var height = (this.headerHeight - 2) / 3;
      var newLeft = 0;
      var start = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate(), 0, 0);
      var end = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate(), 0, 0);

      var allMonths = Array.from($(`[monthName=monthName${this.ganttID}]`));

      var diff = this.$dateTime.getDateTimeDifference(this.endDate, this.startDate);
      var startTime = this.startDate;

      var totalHours = diff.hour * 60 + diff.min;
      var firstDay = 1440 - ((this.startDate.getHours() * 60) + this.startDate.getMinutes());

      if (allMonths.length > 0) {
        if (start.getTime() == end.getTime()) {
          var diff = this.$dateTime.getDateTimeDifference(this.endDate, this.startDate);
          var gridCount = ((diff.hour * 60) + diff.min) / this.minSteps;
          allMonths[0].setAttribute('width', columnSize * gridCount);
          allMonths[0].setAttribute('x', 0);
        } else {
          var allLines = Array.from($(`[monthLine=monthLine${this.ganttID}]`));

          var currentGrid = 0;
          allMonths.forEach((l, i) => {
            var grid = parseInt(l.getAttribute('gridCount'));
            l.setAttribute('width', columnSize * grid);
            l.setAttribute('x', (currentGrid * columnSize));
            currentGrid += grid;

            if (allLines[i]) {
              allLines[i].setAttribute('x1', (currentGrid * columnSize));
              allLines[i].setAttribute('x2', (currentGrid * columnSize));
            }
          });
        }
      } else {
        if (start.getTime() == end.getTime()) {
          var fObject = this.createForeignObject(height, rightHeaderItems.getBoundingClientRect().width, 0, height);
          fObject.setAttribute('monthName', `monthName${this.ganttID}`);
          var dateSpan = this.createSpan(`${this.monthName[start.getMonth()]}, ${start.getDate()}`, 9);
          if (new Date(startTime.getFullYear(), startTime.getMonth(), startTime.getDate(), 0, 0).getTime() == 
            new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0).getTime()) {
            dateSpan.style.backgroundColor = 'aqua';
          }
          fObject.appendChild(dateSpan);
          rightHeaderItems.appendChild(fObject);
        } else {
          var startTime = this.startDate;

          var firstDayObj = this.createForeignObject(height, firstDay / this.minSteps * columnSize, newLeft, height);
          firstDayObj.setAttribute('monthName', `monthName${this.ganttID}`);
          firstDayObj.setAttribute('gridCount', firstDay / this.minSteps);
          var dateSpan = this.createSpan(`${this.monthName[startTime.getMonth()]}, ${startTime.getDate()}`, 9);
          if (new Date(startTime.getFullYear(), startTime.getMonth(), startTime.getDate(), 0, 0).getTime() == 
            new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0).getTime()) {
            dateSpan.style.backgroundColor = 'aqua';
          }
          firstDayObj.appendChild(dateSpan);
          rightHeaderItems.appendChild(firstDayObj);

          totalHours -= firstDay;
          var dayIndex = 1;
          while (totalHours > 1440) {
            startTime = new Date(startTime.getTime() + (1440 * 60000));
            newLeft = ((firstDay + (1440 * (dayIndex - 1))) / this.minSteps * columnSize);

            var line = this.createLine(newLeft, newLeft, height, height * 2, null, 0.75);
            line.setAttribute('monthLine', `monthLine${this.ganttID}`);
            rightHeaderItems.appendChild(line);

            var fObject = this.createForeignObject(height, 1440 / this.minSteps * columnSize, newLeft, height);
            fObject.setAttribute('monthName', `monthName${this.ganttID}`);
            fObject.setAttribute('gridCount', 1440 / this.minSteps);
            var dateSpan = this.createSpan(`${this.monthName[startTime.getMonth()]}, ${startTime.getDate()}`, 9);
            if (new Date(startTime.getFullYear(), startTime.getMonth(), startTime.getDate(), 0, 0).getTime() == 
              new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0).getTime()) {
              dateSpan.style.backgroundColor = 'aqua';
            }
            fObject.appendChild(dateSpan);
            rightHeaderItems.appendChild(fObject);

            totalHours -= 1440;
            dayIndex++;
          }

          startTime = new Date(startTime.getTime() + (totalHours * 60000));
          newLeft = ((firstDay + (1440 * (dayIndex - 1))) / this.minSteps * columnSize);

          var lastLine = this.createLine(newLeft, newLeft, height, height * 2, null, 0.75);
          lastLine.setAttribute('monthLine', `monthLine${this.ganttID}`);
          rightHeaderItems.appendChild(lastLine);

          var lastDayObject = this.createForeignObject(height, totalHours / this.minSteps * columnSize, newLeft, height);
          lastDayObject.setAttribute('monthName', `monthName${this.ganttID}`);
          lastDayObject.setAttribute('gridCount', totalHours / this.minSteps);
          var dateSpan = this.createSpan(`${this.monthName[startTime.getMonth()]}, ${startTime.getDate()}`, 9);
          if (new Date(startTime.getFullYear(), startTime.getMonth(), startTime.getDate(), 0, 0).getTime() == 
            new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0).getTime()) {
            dateSpan.style.backgroundColor = 'aqua';
          }
          lastDayObject.appendChild(dateSpan);
          rightHeaderItems.appendChild(lastDayObject);
        }
      }

      rightHeaderContainer.setAttribute('width', rightHeaderItems.getBoundingClientRect().width - 10);
    },
    setNowLine: function() {
      if (nowLineTimer) {
        console.log('clear');
        clearInterval(this.moveNowLine);
      }

      var size = this.gridSize;
      if (columnSize > size) {
        size = columnSize;
      }

      var offset = this.$dateTime.getDateTimeDifference(new Date(), this.startDate);
      var totalOffsetMin = (offset.hour * 60) + offset.min;
      var xPos = totalOffsetMin / this.minSteps * size;

      var nowLine = this.createLine(xPos, xPos, this.headerHeight, bottom, 'red', 1);
      nowLine.setAttribute('id', `nowLine${this.ganttID}`);
      
      var fObject = this.createForeignObject('20', '35', xPos, this.headerHeight);
      fObject.setAttribute('id', `nowText${this.ganttID}`);
      var span = this.createSpan('Now', 12);
      span.style.backgroundColor = 'rgba(255,0,0,0.5)';
      fObject.appendChild(span);
      
      rightHeaderItems.appendChild(fObject);
      rightHeaderItems.appendChild(nowLine);

      var delay = 60 - new Date().getSeconds();
      setTimeout(() => {
        this.moveNowLine();
        nowLineTimer = setInterval(this.moveNowLine, 60 * 1000);
      }, delay * 1000);
    },
    moveNowLine: function() {
      var size = this.gridSize;
      if (columnSize > size) {
        size = columnSize;
      }

      var offset = this.$dateTime.getDateTimeDifference(new Date(), this.startDate);
      var totalOffsetMin = (offset.hour * 60) + offset.min;
      var xPos = totalOffsetMin / this.minSteps * size;

      var nowLine = document.getElementById(`nowLine${this.ganttID}`);
      var nowText = document.getElementById(`nowText${this.ganttID}`);

      nowLine.setAttribute('x1', xPos);
      nowLine.setAttribute('x2', xPos);
      nowText.setAttribute('x', xPos);
    },
    populateData: function() {
      leftContentDiv.innerHTML = '';
      rightContentDiv.innerHTML = '';

      var childCount = -1;
      var currentChild = -1;
      leftContentDiv.style.height = `${this.items.length * (this.rowHeight)}px`;
      this.items.forEach((t, mainIndex) => {
        // Left header section
        var leftHeaderDiv = this.createContentDiv(mainIndex);
        this.leftHeader.forEach((l, li) => {
          var span = this.createSpan(t[l['key']], 9, 'left');
          span.style.minWidth = `calc(100% / ${this.leftHeader.length})`;
          span.style.maxWidth = `calc(100% / ${this.leftHeader.length})`;
          span.style.overflow = 'hidden';
          if (li == 0 && t['children']) {
            childCount = t['children'];
            span.style.paddingLeft = '15px';
            leftHeaderDiv.appendChild(this.createCollapsibleButton(mainIndex, t['children']));
          }
          
          if (li == 0 && currentChild < childCount && t['task']) {
            span.style.paddingLeft = '25px';
          }

          leftHeaderDiv.appendChild(span);
        });
        leftContentDiv.appendChild(leftHeaderDiv);
        // Left header section

        // Right header section
        if (t['task']) {
          var rightDiv = this.createContentDiv(mainIndex);
          rightDiv.style.position = 'relative';
          t['task'].forEach((tt) => {
            rightDiv.appendChild(this.createTask(mainIndex, tt[this.allKeys.starttime], tt[this.allKeys.duration], tt[this.allKeys.progress], tt[this.allKeys.color], tt[this.allKeys.progressColor]));
          });
          rightContentDiv.appendChild(rightDiv);
        } else {
          rightContentDiv.appendChild(this.createContentDiv(mainIndex));
        }
        // Right header section

        if (currentChild == childCount - 1) {
          currentChild = -1;
          childCount = -1;
        }

        if (childCount > 0) {
          currentChild++;
        }
      });
    },
    collapseClicked: function(e) {
      var hide;
      var imgSrc = e.target.getAttribute('src');
      var parentIndex = e.target.getAttribute('index');
      var childCount = e.target.getAttribute('childCount');

      if (imgSrc == 'https://img.icons8.com/emoji/48/000000/minus-emoji.png') {
        hide = true;
        e.target.setAttribute('src', 'https://img.icons8.com/emoji/48/000000/plus-emoji.png');
      } else {
        hide = false;
        e.target.setAttribute('src', 'https://img.icons8.com/emoji/48/000000/minus-emoji.png');
      }

      while (childCount > 0) {
        parentIndex++;
        childCount--;
        var allRows = Array.from($(`[ganttRow=ganttRow${parentIndex}${this.ganttID}]`));
        
        allRows.forEach((a) => { a.style.display = hide ? 'none' : 'flex' });
      }
    },
    // Add line methods
    // Tooltip methods
    taskHoverIn: function(e) {
      tooltip.innerHTML = '';

      var target = e.target;
      var targetIndex = target.getAttribute('index');
      var targetStart = target.getAttribute('start');
      var targetEnd = target.getAttribute('end');

      var tasks = this.items[targetIndex]['task'].filter((t) => { return t[this.allKeys['starttime']] >= targetStart && t[this.allKeys['starttime']] < targetEnd });
      
      tasks.forEach((t) => {
        tooltip.appendChild(this.createHoverTask(t));
      });

      tooltip.style.left = `${e.pageX - 125}px`;
      tooltip.style.top = `${e.pageY}px`;

      tooltip.classList.remove('tooltip-hidden');
    },
    taskHoverOut: function(e) {
      tooltip.classList.add('tooltip-hidden');
    },
    taskHoverMove: function(e) {
      var height = tooltip.getBoundingClientRect().height;
      tooltip.style.left = `${e.pageX - 125}px`;
      tooltip.style.top = `${e.pageY - height}px`;
    },
    // Tooltip methods
    resize: function(e) {
      svgContainer = document.getElementById(`svgContainer${this.ganttID}`).getBoundingClientRect();
      grid = document.getElementById(`gridContainer${this.ganttID}`);
      grid.innerHTML = '';

      rightHeaderContainer = document.getElementById(`rightHeaderContainer${this.ganttID}`);
      rightHeaderItems = document.getElementById(`rightHeaderItems${this.ganttID}`);
      leftHeaderContainer = document.getElementById(`leftHeaderContainer${this.ganttID}`);
      leftHeaderItems = document.getElementById(`leftHeaderItems${this.ganttID}`);

      rightContainerDiv = document.getElementById(`rightContainerDiv${this.ganttID}`);
      contentContainer = document.getElementById(`contentContainer${this.ganttID}`);
      svgRightContainer = document.getElementById(`svgRightContainer${this.ganttID}`);
      svgRightItems = document.getElementById(`svgRightItems${this.ganttID}`);

      rightContentDiv = document.getElementById(`rightContentDiv${this.ganttID}`);

      leftContentDiv = document.getElementById(`leftContentDiv${this.ganttID}`);

      innerLines = document.getElementById(`innerLines${this.ganttID}`);

      tooltip = document.getElementById(`tooltip${this.ganttID}`);
      tooltip.style.position = 'fixed';
      tooltip.style.top = '100px';
      tooltip.style.left = '100px';
      tooltip.style.zIndex = '99';

      innerLines.innerHTML = '';

      top = 10;
      right = svgContainer.width - 10;
      bottom = svgContainer.height - 10;
      left = 10;

      grid.appendChild(this.createLine(left, right, bottom, bottom));
      grid.appendChild(this.createLine(left, right, top, top));
      grid.appendChild(this.createLine(left, left, top, bottom));
      grid.appendChild(this.createLine(right, right, top, bottom));

      innerLines.appendChild(this.createLine(left, right - 8, top + this.headerHeight, top + this.headerHeight));

      this.setSplitterPosition();
      this.setLeftContainerLine();
      this.setLeftContainerHeader();
      this.setTimeLineLine();

      if (new Date() >= this.startDate && new Date() <= this.endDate) {
        var nowLine = document.getElementById(`nowLine${this.ganttID}`);
        if (!nowLine) {
          this.setNowLine();
        } else {
          this.moveNowLine();
        }
      }

      this.populateData();
    },
    populateGantt: function() {
      console.log('Populate Gantt');

      if (rightHeaderItems) {
        rightHeaderItems.innerHTML = '';
      }

      this.resize();
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize);
    document.addEventListener('mouseup', this.resizeMouseUp);
    document.addEventListener('mousemove', this.resizeMouseMove);

    // this.leftHeader = [ 
    //   { key: 'JobNo', title: 'Job #' },
    //   { key: 'cuName', title: 'Customer' },
    //   { key: 'totalCont', title: 'Total Container' }
    // ];

    // this.items = [
    //   { JobNo: 'This is a long job no test', cuName: 'ABC', totalCont: '5', task: [
    //     { starttime: 1600678800000, duration: 10, progress: 0.5, color: 'aqua', progressColor: 'blue', leftText: 'abc', rightText: 'def' },
    //     { starttime: 1600684200000, duration: 90, progress: 1, color: 'aqua', progressColor: 'blue', leftText: 'abc', rightText: 'def' },
    //     { starttime: 1600690200000, duration: 15, progress: 0.8, color: 'yellow', progressColor: 'red', leftText: 'abc', rightText: 'def' },
    //     { starttime: 1600690200000, duration: 15, progress: 0.5, color: 'green', progressColor: 'red', leftText: 'abc', rightText: 'def' },
    //     { starttime: 1600695300000, duration: 20, progress: 0.24, color: 'aqua', progressColor: 'blue', leftText: 'abc', rightText: 'def' },
    //     { starttime: 1600691400000, duration: 75, progress: 0.5, color: 'yellow', progressColor: 'red', leftText: 'abc', rightText: 'def' },
    //   ] },
    //   { JobNo: '5432', cuName: 'TST', totalCont: '12', task: [
    //     { starttime: 1600682400000, duration: 90, progress: 0.5, color: 'green', progressColor: 'red', leftText: 'abc', rightText: 'def' },
    //   ] },
    //   { JobNo: '8579', cuName: 'EHL', totalCont: '37', children: 2 },
    //   { JobNo: '8579-1', cuName: 'EHL', totalCont: '37', task: [
    //     { starttime: 1600685100000, duration: 165, progress: 0.5, color: 'yellow', progressColor: 'red', leftText: 'abc', rightText: 'def' },
    //   ] },
    //   { JobNo: '8579-2', cuName: 'EHL', totalCont: '37', task: [
    //     { starttime: 1600688700000, duration: 1260, progress: 0.5, color: 'yellow', progressColor: 'red', leftText: 'abc', rightText: 'def' },
    //   ] },
    //   { JobNo: '5432-1', cuName: 'TST', totalCont: '12', task: [
    //     { starttime: 1600682700000, duration: 90, progress: 0.5, color: 'green', progressColor: 'red', leftText: 'abc', rightText: 'def' },
    //   ] },
    //   { JobNo: '5432', cuName: 'TST', totalCont: '12', children: 1 },
    //   { JobNo: '5432-1', cuName: 'TST', totalCont: '12', task: [
    //     { starttime: 1600682400000, duration: 90, progress: 0.5, color: 'green', progressColor: 'red', leftText: 'abc', rightText: 'def' },
    //   ] },
    // ];

    // this.allKeys = {
    //   starttime: 'starttime',
    //   duration: 'duration',
    //   progress: 'progress',
    //   color: 'color',
    //   progressColor: 'progressColor',
    //   leftText: 'leftText',
    //   rightText: 'rightText'
    // };

    // this.resize();
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.gantt-chart-main {
  height: 100%;
  width: 100%;
  position: relative;

  > .left-header, > .right-container {
    position: absolute;
    left: 11px;
    top: 11px;
    height: calc(100% - 22px);
  }

  > .left-header {
    // background-color: rgba(255,0,0,0.3);
    background-color: white;
  }

  > .right-container {
    // background-color: rgba(0,0,255,0.3);
    overflow: scroll;
  }

  > .splitter {
    position: absolute;
    height: calc(100% - 20px);
    width: 5px;
    top: 10px;
    cursor: col-resize;
    z-index: 6;
    // background-color: rgba(255, 255, 0, 0.3);
    display: flex;
    justify-content: center;
  }
}
</style>